import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { Routes } from 'common/routeConfig'
import genomateLogo from 'assets/icons/genomate-logo-white.webp'
import LanguageSelector from 'components/languageSelector/LanguageSelector'
import { useHeaderStyles } from './Header.styles'

const AppLogo: React.FC = () => {
    const { t } = useTranslation('common')
    const styles = useHeaderStyles()

    return (
        <NavLink to={Routes.BASE}>
            <div className={styles.appLogoContainer}>
                <div className={styles.logo}>
                    <img
                        className={styles.image}
                        src={genomateLogo}
                        alt={t('a11y.appLogo')}
                    />
                </div>
            </div>
        </NavLink>
    )
}

const Header: React.FC = () => {
    const styles = useHeaderStyles()

    return (
        <header className={styles.header} id="header">
            <AppLogo />
            <div className={styles.actions}>
                <LanguageSelector />
            </div>
        </header>
    )
}

export default Header
